import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import Button from "@mui/material/Button";

type PublicViewStatus = "ACTIVE" | "DRAFT" | "INACTIVE" | string | null | undefined;

const DEFAULT_PUBLIC_SITE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : "https://www.unifteconline.com.br";

const PUBLIC_SITE_URL =
  process.env.REACT_APP_PUBLIC_SITE_URL ||
  process.env.REACT_APP_SITE_URL ||
  process.env.REACT_APP_WEBSITE_URL ||
  DEFAULT_PUBLIC_SITE_URL;

const hasFutureDate = (value?: string | Date | null) => {
  if (!value) return false;

  const date = new Date(value);
  return !Number.isNaN(date.getTime()) && date.getTime() > Date.now();
};

export const canViewPublicRecord = (status: PublicViewStatus, slug?: string | null) =>
  !!slug && (status === "ACTIVE" || status === "DRAFT");

export const getPublicViewUrl = ({
  category,
  status,
  slug,
  publishOn,
  releaseDate,
}: {
  category: string;
  status: PublicViewStatus;
  slug?: string | null;
  publishOn?: string | Date | null;
  releaseDate?: string | Date | null;
}) => {
  if (!slug) return "";

  const shouldPreview =
    status === "DRAFT" ||
    (status === "ACTIVE" && (hasFutureDate(publishOn) || hasFutureDate(releaseDate)));
  const path = `/${category}${shouldPreview ? "/rascunho" : ""}/${slug}`;

  return `${PUBLIC_SITE_URL.replace(/\/$/, "")}${path}`;
};

export const publicViewButtonSx = {
  opacity: "1 !important",
  "&.Mui-disabled": {
    pointerEvents: "none",
    opacity: "0.45 !important",
  },
};

export function PublicViewButton({
  category,
  status,
  slug,
  publishOn,
  releaseDate,
  size = "small",
}: {
  category: string;
  status: PublicViewStatus;
  slug?: string | null;
  publishOn?: string | Date | null;
  releaseDate?: string | Date | null;
  size?: "small" | "medium" | "large";
}) {
  const disabled = !canViewPublicRecord(status, slug);

  return (
    <Button
      component="a"
      href={
        disabled ? undefined : getPublicViewUrl({ category, status, slug, publishOn, releaseDate })
      }
      target="_blank"
      rel="noreferrer"
      variant="outlined"
      color="secondary"
      size={size}
      disabled={disabled}
      startIcon={<LaunchRoundedIcon />}
      sx={publicViewButtonSx}
    >
      Ver
    </Button>
  );
}
